export const DEFAULT_PAGE = '/login';
export const MAIN_PAGE = '/main';
export const POLL_PAGE = '/poll';

///Endpoints//
export const AUTH_ENDPOINT = 'oauth/token';
export const CA_SERVERS_ENDPOINT = 'api/LoginSign/getCAServers';
export const CHALLENGE_ENDPOINT = 'api/LoginSign/challenge';
export const REGISTER_ENDPOINT = 'api/auth/register';
export const ACTIVATE_ENDPOINT = 'api/auth/activate';
export const RESTORE_PASSWORD_ENDPOINT = 'api/auth/restorePassword';
export const RESET_PASSWORD_ENDPOINT = 'api/auth/resetPassword';